// extracted by mini-css-extract-plugin
export default {"row":"metadata_row__oTgh7","label":"metadata_label__Bs+MF","groupReservationLimit":"metadata_groupReservationLimit__+ypAE"};